var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[(
      _vm.previewable &&
      _vm.info.url &&
      !['doc', 'docx', 'pdf'].includes(_vm.info.fileType)
    )?_c('iframe',{ref:"iframeContent",staticClass:"iframeContent",attrs:{"scrolling":"no","src":`https://view.officeapps.live.com/op/view.aspx?src=${_vm.info.url}`,"srcdoc":_vm.datum_info.content,"height":_vm.iframeHeight},on:{"load":_vm.iframeOnLoad}}):(
      _vm.previewable &&
      _vm.info.url &&
      (_vm.info.fileType === 'doc' || _vm.info.fileType === 'docx')
    )?_c('div',{staticClass:"doc-preview"},[_c('a',{attrs:{"href":`https://view.officeapps.live.com/op/view.aspx?src=${_vm.info.url}`}},[_vm._v("点击word预览文档")])]):(_vm.previewable && _vm.info.url && _vm.info.fileType === 'pdf')?_c('div',{staticClass:"doc-preview"},[_c('Pdf',{ref:"jsPdf",attrs:{"pdfUrl":_vm.info.url,"is_encrypt":_vm.info.is_encrypt}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }